import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

let lenis = null;

// Lenis anula el scroll nativo (scrollIntoView / window.scrollTo), así que los
// saltos a secciones tienen que pasar por su propia API.
// Sin id, sube al inicio de la página.
export const scrollToSection = (id, { immediate = false } = {}) => {
  const target = id ? document.getElementById(id) : 0;
  if (target === null) return;
  if (lenis) lenis.scrollTo(target, { immediate });
  else if (target) target.scrollIntoView({ behavior: immediate ? 'auto' : 'smooth' });
  else window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const SmoothScroll = ({ children }) => {
  const lenisRef = useRef(null);

  useEffect(() => {
    lenisRef.current = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
    });
    lenis = lenisRef.current;

    function raf(time) {
      lenisRef.current?.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenisRef.current?.destroy();
      lenis = null;
    };
  }, []);

  return <>{children}</>;
};